export const WelcomePageSkeleton = () => (
  <>
    {/* ThemeIntegrationBar skeleton */}
    <s-section>
      <s-stack
        direction="inline"
        gap="base"
        alignItems="center"
        justifyContent="space-between"
      >
        <s-stack direction="inline" gap="base" alignItems="center">
          <s-box
            background="subdued"
            borderRadius="small-100"
            blockSize="24px"
            inlineSize="24px"
          />
          <s-box
            background="subdued"
            borderRadius="small-100"
            blockSize="12px"
            maxInlineSize="220px"
          />
          <s-box
            background="subdued"
            borderRadius="small-100"
            blockSize="12px"
            maxInlineSize="40px"
          />
        </s-stack>
        <s-box
          background="subdued"
          borderRadius="small-100"
          blockSize="32px"
          maxInlineSize="100px"
        />
      </s-stack>
    </s-section>

    {/* WelcomeBanner skeleton */}
    <s-section>
      <s-stack direction="block" gap="base">
        <s-box
          background="subdued"
          borderRadius="small-100"
          blockSize="16px"
          maxInlineSize="200px"
        />
        <s-box background="subdued" borderRadius="small-100" blockSize="12px" />
        <s-box
          background="subdued"
          borderRadius="small-100"
          blockSize="12px"
          maxInlineSize="85%"
        />
        <s-box
          background="subdued"
          borderRadius="small-100"
          blockSize="12px"
          maxInlineSize="90%"
        />
      </s-stack>
    </s-section>

    <s-box padding="base" />

    {/* BetaBanner skeleton */}
    <s-section>
      <s-stack direction="block" gap="base">
        <s-box
          background="subdued"
          borderRadius="small-100"
          blockSize="16px"
          maxInlineSize="180px"
        />
        <s-box background="subdued" borderRadius="small-100" blockSize="12px" />
        <s-box
          background="subdued"
          borderRadius="small-100"
          blockSize="12px"
          maxInlineSize="80%"
        />
      </s-stack>
    </s-section>
  </>
);
